import ObjectCopyService from "external-services/object-copy-service/index";
import BlockoutValidationService from "app/services/blockoutValidation/blockoutValidation.service";
import BlockOutsService from "external-services/blockouts-service/blockouts.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import CompareObjectsService from 'external-services/compare-objects-service/CompareObjects';
import moment from "moment";
import {ChangeLogOperation} from "app/app.types";
import {uniqBy} from 'lodash-es';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import store from 'appRoot/Store';
import {setSelectedSchedule} from 'app/reducers/schedule/slice';
const NS = 'BlockoutEditorCtrl'; // jshint ignore:line

export default function BlockoutEditorCtrl(
  $state, $filter, $stateParams, $mdToast, $scope, appConstants, $rootScope
) {
  "ngInject";

  var vm = this;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;

  vm.repeatTypes = appConstants.Blockout.RepeatTypes;
  vm.repeatBlockoutsAllowed = window.config.repeatBlockouts;
  vm.repeatOptions = [{
    label: 'Single Blockout',
    value: vm.repeatTypes.NoRepeat
  }];

  if (vm.repeatBlockoutsAllowed) {
    vm.repeatOptions.push({
      label: 'Daily',
      value: vm.repeatTypes.Daily
    });
    vm.repeatOptions.push({
      label: 'Weekly',
      value: vm.repeatTypes.Weekly
    });
    vm.repeatOptions.push({
      label: 'Monthly',
      value: vm.repeatTypes.Monthly
    });
    vm.repeatOptions.push({
      label: 'Yearly',
      value: vm.repeatTypes.Yearly
    });
    vm.repeatOptions.push({
      label: 'Close',
      value: vm.repeatTypes.Close
    });
  }

  vm.dailyRepeatOn = [{
    label: 'Everyday',
    value: 'everyday'
  }, {
    label: 'Weekdays',
    value: 'weekdays'
  }, {
    label: 'Weekends',
    value: 'weekends'
  }];

  vm.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  vm.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  vm.dates = [];

  // Register functions
  vm.layoutChange = layoutChange;
  vm.blockTable = blockTable;
  vm.unblockTable = unblockTable;
  vm.toggleBlockSection = toggleBlockSection;
  vm.sectionSelected = sectionSelected;
  vm.selectAllSections = selectAllSections;
  vm.cancel = cancel;
  vm.save = save;
  vm.tryAgain = tryAgain;
  vm.oneWeekDaySelected = oneWeekDaySelected;
  const timezoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timezoneId);
  vm.maxStartDateTime = DateUtilsService.setFutureDateInISO(new Date(), 5);
  vm.maxEndDateTime =  DateUtilsService.setFutureDateInISO(new Date(), 5);
  vm.isBlockOutComplete = isBlockOutComplete;
  vm.setMaxEndDate = setMaxEndDate;
  vm.showStaffName = false;
  vm.staffNameRequired = false;
  let originalblockout = null;
  let modifiedValue = [];
  //vm.updateEndTime = updateEndTime;

  init();

  function init() {

    getGeneralSettings();

    if (!$stateParams.id) {
      $state.go('settings.blockouts');
      return;
    }

    if ($stateParams.id !== 'new') {
      // editing allow dates in the past
      vm.startDate = new Date(2000, 1, 1);
      getBlockout($stateParams.id);
    } else {
      // new
      vm.blockout = {
        blockedTables: [],
        blockedSections: [],
        repeatType: vm.repeatTypes.NoRepeat,
        weeklyDay: {},
        excludedDates: [],
        staffName : ''
      };
      getSections();
    }

    $rootScope.$on('remove-date', function(date, dateChanged){
      CompareObjectsService.addToArray(modifiedValue, dateChanged, 'Excluded Dates', '', 'Remove');
    })

    $rootScope.$on('dateChangedInDirective', function(evt, data, dateAdded) { // To get the changed date event from the DateTimePopUp Directive.

      if(data === 'startDateTime'){
        setMaxEndDate(vm.blockout.startDateTime);
      }
      else if(data === 'startDate'){
        setMaxEndDate(vm.blockout.startDate);
      }
      else if(data === 'endDate')
      {
        //Incase end date is changed after end time is selected, update the new end date to end time's date part
        if (vm.blockout.repeatType === vm.repeatTypes.Close && vm.blockout.endTime) {
          updateEndTime();
        }
      }
      else if(data === 'endTime'){
        // Set blockout end time's date to end date set in the UI
          updateEndTime();
      }

      if(data === 'addDate')
      {
        CompareObjectsService.addToArray(modifiedValue, 'Exluded Date', '', moment(dateAdded).format('DD MMM YY h:mma'), ChangeLogOperation.AddData);
      }
      else
      {
        CompareObjectsService.addToArray(modifiedValue, data, '', moment(dateAdded).format('DD MMM YY h:mma'), ChangeLogOperation.AddData);
      }

    });
  }

  function getGeneralSettings()
  {
    GeneralSettingsService.get().then(function (settings) {

      if ($stateParams.id === 'new') {
        if(settings.staffRequiredCreateBlockout)
        {
          vm.staffNameRequired = true;
          vm.showStaffName = true;
        }
      }
      else if(settings.staffRequiredEditBlockout)
      {
        vm.showStaffName = settings.staffRequiredEditBlockout;
      }
    });
  }

  function getBlockout(id) {
    BlockOutsService.getById(id).then(function (blockout) {

      if (blockout.repeatType === vm.repeatTypes.Close) {
        //If close is for whole day, in which case the hour values are all set to 4AM,
        // set the end block date back by 1 day
        if (DateUtilsService.isTimeEqualsDayEnd(blockout.endDate) && DateUtilsService.isTimeEqualsDayEnd(blockout.startDate)) {
          blockout.endDate.setDate(blockout.endDate.getDate() - 1);
        }

      }

      vm.blockout = {
        ...blockout,
        blockedTables: uniqBy(blockout.blockedTables, '_id')
      };
      if (vm.blockout.createdDate) {
        vm.createdDate = DateUtilsService.toVenueTime(vm.blockout.createdDate, timezoneId);
      }
      if (vm.blockout.updatedDate) {
        vm.updatedDate = DateUtilsService.toVenueTime(vm.blockout.updatedDate, timezoneId);
      }
      getSections();

      vm.blockout.staffName = '';
      originalblockout = ObjectCopyService.angularSafeCopy(vm.blockout);

    }).catch(function (err) {
      console.error('error getting blockout', id, err);
    });
  }

  function getSections() {
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = sections;
      var sectionLookUp = {};
      for (var i = sections.length - 1; i >= 0; i--) {
        var section = sections[i];
        sectionLookUp[section._id] = section;
      }
      vm.sectionLookUp = sectionLookUp;
      getLayouts();
    }).catch(function (err) {
      console.error('error getting sections', err);
    });
  }

  function getLayouts() {
    LayoutsService.getAllLayouts().then(function (layouts) {
      vm.layouts = layouts;
      filterLayouts();
      vm.state = vm.ENTER;
    }).catch(function (err) {
      console.error('faild to load layouts', err);
    });
  }

  function filterLayouts() {
    if (!vm.blockout.blockedSections || !vm.blockout.blockedSections.length) {
      vm.filteredLayouts = vm.layouts;
    } else {
      var filteredLayouts = [];
      for (var i = 0; i < vm.layouts.length; i++) {
        var layout = vm.layouts[i];
        if (vm.blockout.blockedSections.indexOf(layout.sectionId) === -1) {
          filteredLayouts.push(layout);
        }
      }
      vm.filteredLayouts = filteredLayouts;
    }
  }

  function toggleBlockSection(section) {
    var index = vm.blockout.blockedSections.indexOf(section._id);
    if (index === -1) {
      // add block
      vm.blockout.blockedSections.push(section._id);
      CompareObjectsService.addToArray(modifiedValue, 'blockedSections', '', section.name, ChangeLogOperation.AddData);
    } else {
      // remove block
      vm.blockout.blockedSections.splice(index, 1);
      CompareObjectsService.addToArray(modifiedValue, section.name, 'blockedSections', '', ChangeLogOperation.RemoveData);
    }
    filterLayouts();
  }

  function selectAllSections() {
    for (var i = vm.sections.length - 1; i >= 0; i--) {
      var section = vm.sections[i];
      var index = vm.blockout.blockedSections.indexOf(section._id);
      if (index === -1) {
        vm.blockout.blockedSections.push(section._id);
      }
    }
  }

  function sectionSelected(section) {
    var index = vm.blockout.blockedSections.indexOf(section._id);
    return (index === -1) ? false : true;
  }

  function layoutChange() {
    vm.selectedLayout = vm.layouts[vm.selectedLayoutIndex];
    TablesLookupService.getAllTablesByIds(vm.selectedLayout.tables).then(function (tables) {
      vm.layoutTables = $filter('alphaSortFilter')(tables, 'name');
      vm.displayLayoutTables = $filter('idsRemoveFilter')(vm.layoutTables, vm.blockout.blockedTables);

    }).catch(function (err) {
      console.error('error getting tables', err);
    });
  }

  function blockTable(table, layout) {


    // make sure the table is not already blocked
    var blockedIds = vm.blockout.blockedTables.map(function (table) {
      return table._id;
    });
    if (blockedIds.indexOf(table._id) === -1) {
      var blockTable = {
        _id: table._id,
        name: table.name,
        layoutName: layout.name
      };
      vm.blockout.blockedTables.push(blockTable);

      CompareObjectsService.addToArray(modifiedValue, 'Blockout Table', '' ,`${layout.name} T${table.name}`, ChangeLogOperation.AddData);

      vm.displayLayoutTables = $filter('idsRemoveFilter')(vm.layoutTables, vm.blockout.blockedTables);
    }
  }

  function unblockTable(table) {
    var blockedIds = vm.blockout.blockedTables.map(function (table) {
      return table._id;
    });
    var index = blockedIds.indexOf(table._id);
    vm.blockout.blockedTables.splice(index, 1);

    CompareObjectsService.addToArray(modifiedValue, `Table ${table.layoutName} T${table.name}`, 'Blockout Table', '', ChangeLogOperation.RemoveData );
    vm.displayLayoutTables = $filter('idsRemoveFilter')(vm.layoutTables, vm.blockout.blockedTables);
  }

  function oneWeekDaySelected() {

    if (!vm.blockout.weeklyDay) {
      return false;
    }
    for (var key in vm.blockout.weeklyDay) {
      var option = vm.blockout.weeklyDay[key];
      if (option) {
        return true;
      }
    }
    return false;
  }

  function isBlockOutComplete() {
    return vm.blockout.repeatType === vm.repeatTypes.Close || vm.blockout.blockedTables.length > 0 || vm.blockout.blockedSections.length > 0;
  }

  function cancel() {
    $state.go('settings.blockouts');
  }

  function isYearlyDayValid() {
    if (vm.blockout.repeatType !== vm.repeatTypes.Yearly)
      return true;
    else {
      return BlockoutValidationService.isYearlyDayValid(vm.blockout.yearlyDay, vm.blockout.yearlyMonth);
    }
  }

  function updateEndTime()
  {
    if(vm.blockout.endDate)
    {
      // Setting day, month and year of end date to end time's value
      vm.blockout.endTime.setDate(vm.blockout.endDate.getDate());
      vm.blockout.endTime.setFullYear(vm.blockout.endDate.getFullYear());
      vm.blockout.endTime.setMonth(vm.blockout.endDate.getMonth());
    }

  }

  function save(isValid) {

    if(originalblockout) {

      var changeDetails =
        CompareObjectsService.computeObjectDifference(originalblockout, vm.blockout, '', false, ["staffName"]);

         // Check if there are any changes done in the page, if there was, check if staff name is required
         // If staff name is required and blank, prompt the user to enter staff name
        if(modifiedValue.length !== 0 || changeDetails.length !==0)
        {
          if (vm.showStaffName && !vm.blockout.staffName) {
            vm.staffNameRequired = true;
            vm.displayErrors = true;
            return;
          }

          for(let i=0; i < changeDetails.length; i++)
          {
            CompareObjectsService.addToArray(modifiedValue, changeDetails[i].property, changeDetails[i].originalValue, changeDetails[i].newValue, changeDetails[i].operation, true);
          }
        }
      }
      else if (isValid) {
        modifiedValue = [];
        CompareObjectsService.addToArray(modifiedValue, 'Blockout', '', vm.blockout.name, ChangeLogOperation.NewData);

      if (vm.blockout.startDate) {
        CompareObjectsService.addToArray(modifiedValue, 'startDate', '', `${moment(vm.blockout.startDate).format('DD MMM YY')} ${moment(vm.blockout.startTime).format('h:mma')}`, ChangeLogOperation.NewData);
      }
      else if (vm.blockout.startDateTime) {
        CompareObjectsService.addToArray(modifiedValue, 'startDate', '', moment(vm.blockout.startDateTime).format('DD MMM YY h:mma'), ChangeLogOperation.NewData);
      }

      if (vm.blockout.endDate) {
        CompareObjectsService.addToArray(modifiedValue, 'endDate', '', `${moment(vm.blockout.endDate).format('DD MMM YY')} ${moment(vm.blockout.endTime).format('h:mma')}`, ChangeLogOperation.NewData);
      }
      else if (vm.blockout.endDateTime) {
        CompareObjectsService.addToArray(modifiedValue, 'endDate', '', moment(vm.blockout.endDateTime).format('DD MMM YY h:mma'), ChangeLogOperation.NewData);
      }
    }

    if (isValid && isBlockOutComplete() && isYearlyDayValid()) {

      vm.state = vm.LOADING;
      var blockout = ObjectCopyService.angularSafeCopy(vm.blockout);
      // CLI-165: Grid Sync notification is fired centrally in BlockOutsService.save
      BlockOutsService.save(blockout).then(function () {
        console.log("[BLOCKOUT UPDATE] - Saving changes");

        store.dispatch(setSelectedSchedule({ useCachedScheduleLookup: false }));


        vm.state = vm.ENTER;
        $mdToast.show(
          $mdToast.simple()
            .content('Blockout Saved')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );

        // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
        // if (modifiedValue.length > 0) {
        //   ChangeLoggerService.save(modifiedValue, 'changelog_blockouts', vm.blockout.staffName, vm.blockout.name);
        // }


        $state.go('settings.blockouts');
      }).catch(function () {
        // the block failed to save
        vm.state = vm.ERROR;
      });
    } else {
      vm.displayErrors = true;
    }
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function setMaxEndDate(date, years = 5) {
    vm.maxEndDateTime = DateUtilsService.setFutureDateInISO(date, years);
  }

}
